import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnInit,
  OnDestroy,
  HostBinding,
  ChangeDetectorRef,
  SkipSelf,
} from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Subscription } from 'rxjs';

import { MediaQueryService } from '@fcom/common';
import { CmsArticle } from '@fcom/core-api';
import { unsubscribe } from '@fcom/core/utils';

@Component({
  selector: 'fin-milestone',
  templateUrl: 'milestone.component.html',
  styleUrls: ['./milestone.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MilestoneComponent implements OnInit, OnDestroy {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @HostBinding('class') hostClass = 'flex flex--column';
  @HostBinding('class.flex--basis-full') get hostClassFlexBasisFull(): boolean {
    return this.isTabletDownBreakpoint;
  }
  @HostBinding('style.flex-basis') get hostStylesFlexBasis(): string | undefined {
    return this.isTabletDownBreakpoint ? undefined : 'calc(50% - 0.6rem)';
  }

  @Input() public content: CmsArticle;
  @Input() public tierPointsCurrentPeriod: number;

  isUnlocked: boolean;
  isTabletDownBreakpoint: boolean;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private mediaQueryService: MediaQueryService,
    @SkipSelf() private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.isUnlocked = this.tierPointsCurrentPeriod >= this.content.localSettings?.milestonePoints;

    this.subscriptions.add(
      this.mediaQueryService.isBreakpoint$('tablet_down').subscribe((isTabledDownBreakpoint) => {
        this.isTabletDownBreakpoint = isTabledDownBreakpoint;
        this.changeDetectorRef.detectChanges();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }
}
